<div class="location-warehouse-app-scanner-popup-barcode">
  <div class="row d-flex justify-content-start">
    <div class="col-9">
      <input
        type="text"
        autofocus="on"
        (keyup.enter)="onBarcodeScanChange($event)"
        class="lum-input lum-input--small"
        placeholder="Scan barcode or Type"
        [(ngModel)]="scan.value"
        #searchInputRef
      />
    </div>
    <div class="col-auto">
      <button
        (click)="onScan()"
        class="lum-button lum-button--primary lum-button--large"
        [disabled]="loadingScan"
      >
        <i class="fas fa-spinner fa-spin" *ngIf="loadingScan"></i> Search
      </button>
    </div>
  </div>
</div>
